import React, { useEffect, useState, useRef } from "react"
import "./AddProgram.scss"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import Country from "../../../utils/Data/Country"
import * as Yup from "yup"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { InputNumber } from "primereact/inputnumber"
import { useNavigate, useLocation } from "react-router-dom"
import programApi from "Api/programApi"
import UniversityApi from "Api/UniversityApi"

import { Toast } from 'primereact/toast'

const AddProgram = () => {
  document.title = "Add Program"
  const [loading, setLoading] = useState(false)
  const toast = useRef(null);
  const navigate = useNavigate("")
  const location = useLocation()
  const accessToken = localStorage.getItem("accessToken")
  const ProgramInitialData = {
    programName: "",
    duration: "",
    level: "",
    eligibilityCriteria: "",
    totalSeats: "",
    tuitionFee: "",
    admissionFee: "",
    Scholarship: "",
    intakeSeats: "",
    modeOfStudy: "",
    description: "",
    university: "",
    Institution: "",
  }

  const [programData, setProgramData] = useState(ProgramInitialData)

  const [errors, setErrors] = useState({})
  const handleProgramDataChange = (name, value) => {
    setProgramData({ ...programData, [name]: value })
    setErrors({ ...errors, [name]: "" })
  }

   const programOptions = [
    { label: "Undergraduate", value: "Undergraduate" },
    { label: "Postgraduate", value: "Postgraduate" },
    { label: "Certification Program", value: "Certification Program" },
    { label: "Fellowship", value: "Fellowship" }
  ];

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Program", link: "#" },
    { label: "Add Program", link: "#" },
  ]
  const typeOptions = [
    { name: "underGraduate", code: "underGraduate" },
    { name: "postGraduate", code: "postGraduate" },
  ]
  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]
  const modeofStudyOptions = [
    { name: "Online", code: "Online" },
    { name: "Offline", code: "Offline" },
    { name: "Hybrid", code: "Hybrid" },
  ]
  const [uniMenu, setUniMenu] = useState([])
  const universityDropDown = () => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    UniversityApi.getUniversityMenuList(config)
      .then(res => {
        setUniMenu(res.data.university)
      })
      .catch(error => {
        console.log(error)
      })
  }
  useEffect(() => {
    universityDropDown()
  }, [accessToken])

  const [instituteMenu, setInstituteMenu] = useState([])
  const fetchInstituteByUniId = universityCode => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }
    UniversityApi.getCollegesByUniversity(universityCode, config)
      .then(res => {
        setInstituteMenu(res.data.colleges)
      })
      .catch(error => {
        console.log(error)
      })
  }

  // Store pending institution data to set after instituteMenu loads
  const pendingInstitutionRef = useRef(null)
  const pendingUniversityRef = useRef(null)

  // Auto-populate fields when coming from Data Completion Dashboard
  useEffect(() => {
    if (location.state && !programData.university && !programData.Institution) {
      console.log('=== Add Program - Received State ===')
      console.log('Location state:', location.state)

      const { institutionId, institutionCode, institutionName, universityId, universityCode, universityName, category } = location.state

      // If we have university data
      if (universityId && universityCode && universityName) {
        // Create university object with all required fields
        const university = {
          _id: universityId,
          universityCode: universityCode,
          universityName: universityName
        }

        // Store university data to be set after uniMenu loads
        pendingUniversityRef.current = {
          _id: universityId,
          universityCode: universityCode,
          universityName: universityName
        }

        // Fetch institutions for this university
        fetchInstituteByUniId(universityCode)

        // Store institution data to be set after instituteMenu loads
        pendingInstitutionRef.current = {
          _id: institutionId,
          institutionCode: institutionCode,
          institutionName: institutionName,
          category: category
        }
      } else if (institutionId && institutionCode && institutionName) {
        // If no university but we have institution info
        const institution = {
          _id: institutionId,
          institutionCode: institutionCode,
          institutionName: institutionName,
          category: category
        }

        console.log('Setting institution (no university):', institution)

        // IMPORTANT: Add the institution to instituteMenu so the dropdown can display it
        setInstituteMenu([institution])

        // Set the institution in the form
        handleProgramDataChange("Institution", institution)

        toast.current.show({
          severity: 'info',
          summary: 'Institution Pre-filled',
          detail: `Institution "${institutionName}" has been pre-selected. Please select a university.`,
          life: 3000
        })
      }
    }
  }, [location.state])

  // Set university when uniMenu is populated
  useEffect(() => {
    if (pendingUniversityRef.current && uniMenu.length > 0) {
      const pendingUni = pendingUniversityRef.current
      const matchedUni = uniMenu.find(u => u._id === pendingUni._id || u.universityCode === pendingUni.universityCode)

      if (matchedUni) {
        console.log('Found matching university in menu:', matchedUni)
        handleProgramDataChange("university", matchedUni)
      } else {
        console.warn('Could not find matching university in menu for:', pendingUni)
      }
      pendingUniversityRef.current = null
    }
  }, [uniMenu])

  // Set institution when instituteMenu is populated
  useEffect(() => {
    if (pendingInstitutionRef.current && instituteMenu.length > 0) {
      const pendingInst = pendingInstitutionRef.current

      // Find the matching institution object from the loaded menu
      const matchedInstitution = instituteMenu.find(
        inst => inst._id === pendingInst._id || inst.institutionCode === pendingInst.institutionCode
      )

      if (matchedInstitution) {
        console.log('Found matching institution in menu:', matchedInstitution)
        handleProgramDataChange("Institution", matchedInstitution)

        toast.current.show({
          severity: 'success',
          summary: 'Pre-filled',
          detail: `University and Institution have been pre-selected`,
          life: 3000
        })
      } else {
        console.warn('Could not find matching institution in menu for:', pendingInst)
      }

      // Clear the pending data
      pendingInstitutionRef.current = null
    }
  }, [instituteMenu])

  const ValidateProgram = Yup.object().shape({
    programName: Yup.string().required("Program name is required"),
    // duration: Yup.string().required("Duration is required"),
    // level: Yup.string().required("Level is required"),
    // eligibilityCriteria: Yup.string().required("Eligibility criteria is required"),
    // totalSeats: Yup.number()
    //   .typeError("Invalid Total Seats")
    //   .required("Total seats are required"),
    // tuitionFee: Yup.number()
    //   .typeError("Invalid Tuition Fee")
    //   .required("Tuition fee is required"),
    // admissionFee: Yup.number()
    //   .typeError("Invalid Admission Fee")
    //   .required("Admission fee is required"),
    // Scholarship: Yup.string().required("Scholarship is required"),
    // intakeSeats: Yup.number()
    //   .typeError("Invalid Intake Seats")
    //   .required("Intake Seats is required"),
    // modeOfStudy: Yup.object().shape({
    //   name: Yup.string().oneOf(["Online", "Offline", "Hybrid"], "Invalid Mode of Study").required("Mode of study is required")
    // }).required("Mode of study is required"),
    // description: Yup.string().required("Description is required"),
    Institution: Yup.object().required("Institution is required")
  })

  const addProgram = () => {
    ValidateProgram.validate(programData, { abortEarly: false })
      .then(() => {
        const payload = {
          programName: programData.programName,
          // duration: programData.duration,
          // level: programData.level,
          // eligibilityCriteria: programData.eligibilityCriteria,
          // totalSeats: Number(programData.totalSeats),
          // tuitionFee: Number(programData.tuitionFee),
          // admissionFee: Number(programData.admissionFee),
          // Scholarship: programData.Scholarship,
          // intakeSeats: Number(programData.intakeSeats),
          // modeOfStudy: programData.modeOfStudy?.name?.toLowerCase(),
          // description: programData.description,
          university: programData.university?._id,
          institution: {
            _id: programData.Institution?._id,
            institutionCode: programData.Institution?.institutionCode,
            name: programData.Institution?.institutionName,
            category: programData.Institution?.category
          }
        }
        setLoading(true);

        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }

        programApi
          .addProgram(payload, config)
          .then(res => {
            if (res.data.status) {
              toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: res.data.message,
                life: 3000
              });
              setTimeout(() => {
                setLoading(false);
                // Navigate back to data completion dashboard if coming from there
                if (location.state?.returnToDashboard) {
                  navigate("/data-completion");
                } else {
                  navigate("/programlist");
                }
              }, 1000);
            } else {
              setLoading(false);
              toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: res.data.message,
                life: 3000
              });
            }
          })
          .catch(error => {
            setLoading(false);
            toast.current.show({
              severity: 'error',
              summary: 'Error',
              detail: error?.response?.data?.message || "Failed to create program",
              life: 3000
            });
            console.log(error);
          });
      })
      .catch(err => {
        setLoading(false);
        const validationErrors = {};
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        setErrors(validationErrors);
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: "Please fill all the required fields correctly!",
          life: 3000
        });
      });
  }

  return (
    <div className="add-Program">
      <Toast ref={toast} />
      <Row>
        <Col xs="12">
          <div className="program-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Add Program" />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="program-add-form ">
                <div className="program-add-inp">
                  <label htmlFor="university">University</label>

                  <div className="inp-err">
                    <Dropdown
                      value={programData.university}
                      onChange={e => {
                        handleProgramDataChange("university", e.value)
                        fetchInstituteByUniId(e.value.universityCode)
                      }}
                      options={uniMenu}
                      optionLabel="universityName"
                      placeholder="Select University"
                      filter
                    />
                    {errors.university && (
                      <small className="error">{errors.university}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="Institution">Institution</label>

                  <div className="inp-err">
                    <Dropdown
                      value={programData.Institution}
                      onChange={e => {
                        handleProgramDataChange("Institution", e.value)
                      }}
                      options={instituteMenu}
                      optionLabel="institutionName"
                      placeholder="Select Institution"
                      filter
                    />
                    {errors.Institution && (
                      <small className="error">{errors.Institution}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="ProgramName" className="label">
                    Program Name
                  </label>

                  <div className="inp-err">
                    <Dropdown
                      id="ProgramName"
                      value={programData.programName}
                      options={programOptions}
                      onChange={(e) =>
                        handleProgramDataChange("programName", e.value)
                      }
                      placeholder="Select Program"
                      className="inp-field-box"
                    />

                    {errors.programName && (
                      <small className="error">{errors.programName}</small>
                    )}
                  </div>
                </div>


                {/* <div className="program-add-inp">
                  <label htmlFor="duration" className="label">
                    Duration
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="duration"
                      value={programData.duration}
                      onChange={e =>
                        handleProgramDataChange("duration", e.target.value)
                      }
                      placeholder="Enter Duration"
                      className="inp-field-box"
                    />
                    {errors.duration && (
                      <small className="error">{errors.duration}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="level" className="label">
                    Level
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="level"
                      value={programData.level}
                      onChange={e =>
                        handleProgramDataChange("level", e.target.value)
                      }
                      placeholder="Enter Level"
                      className="inp-field-box"
                    />
                    {errors.level && (
                      <small className="error">{errors.level}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="EligibilityCriteria" className="label">
                    EligibilityCriteria
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="eligibilityCriteria"
                      value={programData.eligibilityCriteria}
                      onChange={e =>
                        handleProgramDataChange(
                          "eligibilityCriteria",
                          e.target.value,
                        )
                      }
                      placeholder="Enter EligibilityCriteria"
                      className="inp-field-box"
                    />
                    {errors.eligibilityCriteria && (
                      <small className="error">
                        {errors.eligibilityCriteria}
                      </small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="totalSeats" className="label">
                    TotalSeats
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalSeats"
                      value={programData.totalSeats}
                      onChange={e =>
                        handleProgramDataChange("totalSeats", e.target.value)
                      }
                      placeholder="Enter TotalSeats"
                      className="inp-field-box"
                    />
                    {errors.totalSeats && (
                      <small className="error">{errors.totalSeats}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="tuitionFee" className="label">
                    TuitionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="tuitionFee"
                      value={programData.tuitionFee}
                      onChange={e =>
                        handleProgramDataChange("tuitionFee", e.target.value)
                      }
                      placeholder="Enter TuitionFee"
                      className="inp-field-box"
                    />
                    {errors.tuitionFee && (
                      <small className="error">{errors.tuitionFee}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="admissionFee" className="label">
                    AdmissionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="admissionFee"
                      value={programData.admissionFee}
                      onChange={e =>
                        handleProgramDataChange("admissionFee", e.target.value)
                      }
                      placeholder="Enter AdmissionFee"
                      className="inp-field-box"
                    />
                    {errors.admissionFee && (
                      <small className="error">{errors.admissionFee}</small>
                    )}
                  </div>
                </div>
                <div className="program-add-inp">
                  <label htmlFor="Scholarship" className="label">
                    Scholarship
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="Scholarship"
                      value={programData.Scholarship}
                      onChange={e =>
                        handleProgramDataChange("Scholarship", e.target.value)
                      }
                      placeholder="Enter Scholarship"
                      className="inp-field-box"
                    />
                    {errors.Scholarship && (
                      <small className="error">{errors.Scholarship}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="intakeSeats" className="label">
                    Intake Seats
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="intakeSeats"
                      value={programData.intakeSeats}
                      onChange={e =>
                        handleProgramDataChange("intakeSeats", e.target.value)
                      }
                      placeholder="Enter Intake Seats"
                      className="inp-field-box"
                    />
                    {errors.intakeSeats && (
                      <small className="error">{errors.intakeSeats}</small>
                    )}
                  </div>
                </div>

                <div className="program-add-inp">
                  <label htmlFor="modeOfStudy">Mode Of Study</label>
                  <div className="inp-err">
                    <Dropdown
                      id="modeOfStudy"
                      value={programData.modeOfStudy}
                      onChange={e =>
                        handleProgramDataChange("modeOfStudy", e.value)
                      }
                      optionLabel="name"
                      options={modeofStudyOptions}
                      placeholder=" Select Mode of Study"
                    />
                    {errors.modeOfStudy && (
                      <small className="error">{errors.modeOfStudy}</small>
                    )}
                  </div>
                </div>
                <div className="program-add-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={programData.description}
                      onChange={e =>
                        handleProgramDataChange("description", e.target.value)
                      }
                      placeholder="Enter Description"
                      className="inp-field-box"
                    />
                    {errors.description && (
                      <small className="error">{errors.description}</small>
                    )}
                  </div>
                </div>  */}
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  disabled={loading}
                  onClick={() => {
                    addProgram()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Add"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default AddProgram
